export default "__VITE_ASSET__rEetmkbQ__"